/*
* Доля в процентах. Итог периода нулевой ровно тогда, когда заказов не было, — но топ в этом
* случае тоже пуст, и делить не на что: возвращаем ноль вместо NaN, который прежний экран
* печатал прямо в таблицу.
* */
export const share = (part: number, total: number): number => (total <= 0 ? 0 : (part / total) * 100);
